import { Text, Flex, Box, Spacer } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { CSVLink } from 'react-csv';

import { date as commonDate } from '@finley-technologies/common';
import { DataLake } from '@finley-technologies/finley-types';

import { colors } from '~/packages/common-frontend/colors';
import { CsvResultPreviewTable } from '~/packages/finleyAi/ui/FinleyAiThreadWindow';
import { getPreviewDataRowCountLabel } from '~/packages/finleyAi/ui/FinleyAiUtils';

export const CollateralDataQualityCheckQueryResultsTable = ({
  queryDataItems,
}: {
  queryDataItems: DataLake.AthenaQueryItemData[];
}) => {
  const headers: string[] = useMemo(
    () => (queryDataItems.length ? Object.keys(queryDataItems[0]) : []),
    [queryDataItems],
  );

  if (!queryDataItems.length) {
    return <Text>No results are returned from this query.</Text>;
  }

  const todayFullDateStr = commonDate.currentDateStr();
  const filename = `cdq-test-query-results-${todayFullDateStr}.csv`;

  return (
    <Box mt="24px">
      <Flex alignItems="center" my="24px">
        <Text fontWeight={600}>Results Preview</Text>
        <Text ml="16px" color={colors.black[70]}>
          {getPreviewDataRowCountLabel(queryDataItems.length)}
        </Text>

        <Spacer />

        <CSVLink data={queryDataItems} headers={headers} filename={filename}>
          <Text fontWeight={600}>Download Full Results</Text>
        </CSVLink>
      </Flex>
      <CsvResultPreviewTable previewCsvData={queryDataItems} />
    </Box>
  );
};
